import React from 'react';

/**
 * Wrapper qui active une animation fade-in + slide-up au scroll.
 * L'animation est déclenchée par `useGlobalScrollReveal` (IntersectionObserver)
 * qui ajoute la classe `.is-visible` quand l'élément entre en vue.
 *
 * @param {number} delay - ms de décalage (50/100/150/200/300/400/500)
 * @param {'up'|'scale'|'fade'} variant - style d'entrée
 * @param {string} as - tag HTML (section, div, article...)
 */
export function Reveal({ children, delay = 0, variant = 'up', as = 'div', className = '', ...rest }) {
  const Tag = as;
  const dataProps = {
    'data-reveal': '',
  };
  if (variant !== 'up') dataProps['data-reveal-variant'] = variant;
  if (delay > 0) dataProps['data-reveal-delay'] = String(delay);
  return (
    <Tag className={className} {...dataProps} {...rest}>
      {children}
    </Tag>
  );
}
